import { ActivityImpact } from "../domain";

export const activityImpactInNumber = {
  [ActivityImpact.Small]: 1,
  [ActivityImpact.Medium]: 2,
  [ActivityImpact.Large]: 3
}